import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * Trigger event model: one row per persona trigger evaluated against a message,
 * recording whether it activated and why.
 * @since 1.0.0
 */
export class TriggerEvent extends Model.Class<TriggerEvent>("TriggerEvent")({
  id: Model.Generated(Schema.String),
  conversationId: Schema.String,
  messageId: Schema.String,
  triggerKey: Schema.String,
  activated: Schema.Boolean,
  why: Schema.NullOr(Schema.String),
  createdAt: Model.DateTimeInsertFromDate,
}) {}
